module.exports = __webpack_public_path__ + "img/new3.64057b41.png";